import React, { useEffect, useRef } from 'react';
import { ads, isAdEnabled } from '../ads';
import './AdSlot.css';

const hasCustomContent = (ad) => Boolean(ad.imageUrl || ad.title || ad.text);

const AdSlot = ({ placement }) => {
  const slotRef = useRef(null);
  const ad = ads[placement];
  const hasHtml = Boolean(ad?.html?.trim());

  useEffect(() => {
    if (!ad?.enabled || !hasHtml || !slotRef.current) return undefined;

    const slot = slotRef.current;
    const fragment = document.createRange().createContextualFragment(ad.html);

    Array.from(fragment.querySelectorAll('script')).forEach((script) => {
      const executableScript = document.createElement('script');
      Array.from(script.attributes).forEach(({ name, value }) => {
        executableScript.setAttribute(name, value);
      });
      executableScript.text = script.text;
      script.replaceWith(executableScript);
    });

    slot.replaceChildren(fragment);
    return () => slot.replaceChildren();
  }, [ad, hasHtml]);

  if (!isAdEnabled(placement) || (!hasHtml && !hasCustomContent(ad))) return null;

  const customContent = (
    <>
      {ad.imageUrl && <img className="ad-image" src={ad.imageUrl} alt={ad.imageAlt || ad.title || 'Reklam'} />}
      {(ad.title || ad.text) && (
        <span className="ad-copy">
          {ad.title && <strong>{ad.title}</strong>}
          {ad.text && <span>{ad.text}</span>}
        </span>
      )}
    </>
  );

  return (
    <aside className={`ad-box ad-box--${placement}`} aria-label={ad.label || 'Reklam'}>
      {ad.label && <span className="ad-box__label">{ad.label}</span>}
      {hasHtml ? (
        <div className="ad-box__network" ref={slotRef} />
      ) : ad.href ? (
        <a className="ad-box__link" href={ad.href} target="_blank" rel="sponsored noopener noreferrer">
          {customContent}
        </a>
      ) : (
        <div className="ad-box__content">{customContent}</div>
      )}
    </aside>
  );
};

export default AdSlot;
